// actions.js
import { START_TRACE, STOP_TRACE } from './actionsTypes'

export const startTrace = (traceCreator, traceName) => {
  traceCreator.start()

  return {
    type: START_TRACE,
    payload: { traceName, trace: traceCreator },
  }
}

export const stopTrace = (traceName) => ({
  type: STOP_TRACE,
  payload: traceName,
})
